/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type ReadonlyUint8Array,
} from "@solana/kit";

/** Event emitted when a compressed agent is created */
export type CompressedAgentCreatedEvent = {
  agentId: string;
  owner: Address;
  treeAuthority: Address;
  merkleTree: Address;
  dataHash: ReadonlyUint8Array;
  index: bigint;
  metadataUri: string;
  createdAt: bigint;
};

export type CompressedAgentCreatedEventArgs = {
  agentId: string;
  owner: Address;
  treeAuthority: Address;
  merkleTree: Address;
  dataHash: ReadonlyUint8Array;
  index: number | bigint;
  metadataUri: string;
  createdAt: number | bigint;
};

export function getCompressedAgentCreatedEventEncoder(): Encoder<CompressedAgentCreatedEventArgs> {
  return getStructEncoder([
    ["agentId", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["owner", getAddressEncoder()],
    ["treeAuthority", getAddressEncoder()],
    ["merkleTree", getAddressEncoder()],
    ["dataHash", fixEncoderSize(getBytesEncoder(), 32)],
    ["index", getU64Encoder()],
    ["metadataUri", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["createdAt", getI64Encoder()],
  ]);
}

export function getCompressedAgentCreatedEventDecoder(): Decoder<CompressedAgentCreatedEvent> {
  return getStructDecoder([
    ["agentId", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["owner", getAddressDecoder()],
    ["treeAuthority", getAddressDecoder()],
    ["merkleTree", getAddressDecoder()],
    ["dataHash", fixDecoderSize(getBytesDecoder(), 32)],
    ["index", getU64Decoder()],
    ["metadataUri", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["createdAt", getI64Decoder()],
  ]);
}

export function getCompressedAgentCreatedEventCodec(): Codec<
  CompressedAgentCreatedEventArgs,
  CompressedAgentCreatedEvent
> {
  return combineCodec(
    getCompressedAgentCreatedEventEncoder(),
    getCompressedAgentCreatedEventDecoder(),
  );
}
